window.PXUTheme.jsFeaturedCollection = {
  init: function($section) {
    // Merge section data from schema
    window.PXUTheme.jsFeaturedCollection = $.extend(
      this,
      window.PXUTheme.getSectionData($section)
    );

    // Desktop slider
    if (this.collection_layout === 'slider') {
      this.createSlider('.slider-gallery--desktop', this.products_per);
    }

    // Mobile slider
    if (this.collection_layout_mobile === 'slider') {
      this.createSlider('.slider-gallery--mobile', this.mobile_products_per_row);
    }
  },

  createSlider: function(el, perView) {
    const slider = $(el);
    if (!slider.length) return;

    const numSlides = slider.children().length;

    // Mobile: less than perView, show grid instead of slider
    const isMobile = el.includes('mobile') && numSlides < perView;

    if (isMobile) {
      slider.addClass('mobile-grid'); // CSS handles layout
      return;
    }

    // Initialize Flickity
    $(slider).flickity({
      lazyLoad: 2,
      freeScroll: true,
      imagesLoaded: true,
      draggable: true,
      cellAlign: 'center',
      wrapAround: numSlides > 1,
      pageDots: false,
      contain: true,
      prevNextButtons: numSlides > 1,
      groupCells: perView,
      initialIndex: 0,
      arrowShape: arrowShape,
    });

    $(slider).on('settle.flickity', () => $(slider).flickity('resize'));
  },

  unload: function($section) {
    const $slider = $section.find('.flickity-enabled');
    $slider.flickity('destroy');
  }
};